// components/Footer.tsx

const Footer = () => {
  return (
    <footer className="bg-[#1F2937] text-white py-8 mt-12">
      <div className="container mx-auto px-4">
        {/* Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Left Section */}
          <div>
            <h2 className="text-3xl font-bold mb-2">Bill-Lex</h2>
            <p className="text-lg mb-4">
              Your trusted billing solution for all businesses.
            </p>
            <p className="text-sm">
              © 2025 Bill-Lex by Lexora Technologies OPC Private Limited
            </p>
          </div>

          {/* Center Section */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-semibold mb-2">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="hover:text-green-500">
                  About Us
                </a>
              </li>
              <li>
                <a href="/services" className="hover:text-green-500">
                  Services
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-green-500">
                  Contact
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:text-green-500">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms-and-conditions"
                  className="hover:text-green-500"
                >
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="/refund-policy" className="hover:text-green-500">
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Right Section */}
          <div className="text-center md:text-right">
            <h3 className="text-xl font-semibold mb-2">Follow Us</h3>
            <div className="flex justify-center md:justify-end space-x-4">
              <a
                href="https://facebook.com"
                className="text-lg hover:text-blue-500"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a
                href="https://twitter.com"
                className="text-lg hover:text-blue-400"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                className="text-lg hover:text-blue-700"
              >
                <i className="fab fa-linkedin"></i>
              </a>
              <a
                href="https://instagram.com"
                className="text-lg hover:text-pink-500"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 text-center">
          <p className="text-sm">Made with ❤️ in India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
